import React, {useState,useEffect,useContext} from "react";
import { Container, Row, Col } from "react-bootstrap";
import { User, Mail, Phone } from "lucide-react";
import axios from "axios";
import AppContext from "../../../context/AppContext";
import "../../../assets/css/customer/customerprofile/Profile.css";
import Swal from "sweetalert2";

const Profile = () => {
  const { baseUrl } = useContext(AppContext);

  // ── Login ke waqt localStorage mein save hua customer data ────────
  // Isse hum turant fields bhar dete hain, taake API response aane
  // tak fields khali/blank na dikhein
  const getStoredCustomer = () => {
    try {
      return JSON.parse(localStorage.getItem("customer")) || {};
    } catch {
      return {};
    }
  };
  const storedCustomer = getStoredCustomer();

  // "customerId" key na mile to "customer" object ke andar wala id use karo
  const customerId =
    localStorage.getItem("customerId") || storedCustomer.id;

  // ── Form fields (bound to inputs, change live as user types) ──────
  const [fullname, setFullname] = useState(storedCustomer.fullname || "");
  const [email, setEmail] = useState(storedCustomer.email || "");
  const [phone, setPhone] = useState(storedCustomer.phone || "");
  const [password, setPassword] = useState("");

  // ── Saved profile (only updates on load + after a successful save)
  // Left card reads from here, so it stays static while the user types
  // in the form on the right, and only changes once Save is clicked.
  // Shuru mein localStorage se hi bharta hai (login ka data)
  const [savedProfile, setSavedProfile] = useState({
    fullname: storedCustomer.fullname || "",
    email: storedCustomer.email || "",
    phone: storedCustomer.phone || "",
  });

  const viewProfile = () => {
    const formData = new FormData();
    formData.append(
      "customer_id",
      customerId
    );
   axios.post(`${baseUrl}/customer/profile/viewProfile`,
      formData
      )
      .then((response) => {
        console.log(
          "PROFILE RESPONSE:",
          response.data
        );
        const customer = response.data.customer;

        setFullname(customer.fullname);
        setEmail(customer.email);
        setPhone(customer.phone);

        setSavedProfile({
          fullname: customer.fullname,
          email: customer.email,
          phone: customer.phone,
        });

        // localStorage bhi taaza rakho — agar server ka data
        // localStorage se alag nikla to yahan bhi sync ho jaye
        const existingCustomerData = getStoredCustomer();
        localStorage.setItem(
          "customer",
          JSON.stringify({ ...existingCustomerData, ...customer })
        );
      })
      .catch((error) => {
        console.log(error);
      });
  };
    const updateProfile = () => {
    if (!fullname.trim() || !email.trim() || !phone.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Missing Information",
        text: "Please fill in all fields before saving.",
        confirmButtonColor: "#E8879D",
      });
      return;
    }

    const formData = new FormData();
    formData.append(
      "customer_id",
      customerId
    );

    formData.append(
      "fullname",
      fullname
    );

    formData.append(
      "email",
      email
    );

    formData.append(
      "phone",
      phone
    );

    axios
      .post(
        `${baseUrl}/customer/profile/updateProfile`,
        formData
      )
      .then((response) => {
        console.log(
          "UPDATE RESPONSE:",
          response.data
        );

        // Ab hi left card ko update karo — save successful hone ke baad
        setSavedProfile({
          fullname,
          email,
          phone,
        });

        // localStorage bhi refresh karo — taake header/sidebar mein
        // (jahan bhi customerData use hota hai) naya data turant show ho,
        // Admin Profile mein adminData ke sath jaisa hota hai
        const existingCustomerData = getStoredCustomer();

        const updatedCustomerData = {
          ...existingCustomerData,
          ...(response.data.customer || {}),
          fullname,
          email,
          phone,
        };

        localStorage.setItem(
          "customer",
          JSON.stringify(updatedCustomerData)
        );

        Swal.fire({
          icon: "success",
          title: "Profile Updated!",
          text: "Your profile has been updated successfully.",
          confirmButtonColor: "#E8879D",
        });
      })
      .catch((error) => {
        console.log(error);

        Swal.fire({
          icon: "error",
          title: "Update Failed!",
          text:
            error.response?.data?.message ||
            "Unable to update profile. Please try again.",
          confirmButtonColor: "#E8879D",
        });
      });
  };
    const updatePassword = () => {
    if (!password.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Missing Information",
        text: "Please enter a new password.",
        confirmButtonColor: "#E8879D",
      });
      return;
    }
    if (password.length < 6) {
      Swal.fire({
        icon: "warning",
        title: "Weak Password",
        text: "Password must be at least 6 characters.",
        confirmButtonColor: "#E8879D",
      });
      return;
    }

    const formData = new FormData();
    formData.append(
      "customer_id",
      customerId
    );
    formData.append(
      "password",
      password
    );
    axios
      .post(
        `${baseUrl}/customer/profile/updatePassword`,
        formData
      )
      .then((response) => {
       console.log(
          "PASSWORD RESPONSE:",
          response.data
        );

        setPassword("");

        Swal.fire({
          icon: "success",
          title: "Password Changed!",
          text: "Your password has been updated successfully.",
          confirmButtonColor: "#E8879D",
        });
      })
     .catch((error) => {
        console.log(error);

        Swal.fire({
          icon: "error",
          title: "Update Failed!",
          text:
            error.response?.data?.message ||
            "Unable to update password. Please try again.",
          confirmButtonColor: "#E8879D",
        });
      });
  };
  useEffect(() => {
    viewProfile();
  }, []);

  return (
    <Container fluid>
      <div className="sgc-profile-page">

        {/* ===== HEADER BANNER ===== */}
        <div className="sgc-profile-header">
          <h2 className="sgc-profile-header-title">Profile</h2>
          <p className="sgc-profile-header-sub">Manage your account settings</p>
        </div>

        <Row className="g-4">

          {/* ===== LEFT: OVERVIEW CARD (always shows saved data) ===== */}
          <Col lg={4}>
            <div className="sgc-profile-left-card">
              <div className="sgc-profile-avatar-wrap">
                <div className="sgc-profile-avatar-circle">
                  <span className="sgc-profile-avatar-initials">
                    {savedProfile.fullname?.charAt(0) || "C"}
                  </span>
                </div>

                <div className="sgc-profile-role-badge">Customer</div>
              </div>

              <h3 className="sgc-profile-name">{savedProfile.fullname}</h3>
              <p className="sgc-profile-email">{savedProfile.email}</p>

              <hr className="sgc-profile-divider" />

              {/* ===== ACCOUNT SUMMARY (fills the card, mirrors admin style) ===== */}
              <p className="sgc-profile-summary-title">Account Summary</p>

              <div className="sgc-profile-info-list">
                <div className="sgc-profile-info-item">
                  <div className="sgc-profile-info-icon"><User size={16} /></div>
                  <div>
                    <span className="sgc-profile-info-label">Full name</span>
                    <span className="sgc-profile-info-value">{savedProfile.fullname || "—"}</span>
                  </div>
                </div>

                <div className="sgc-profile-info-item">
                  <div className="sgc-profile-info-icon"><Mail size={16} /></div>
                  <div>
                    <span className="sgc-profile-info-label">Email</span>
                    <span className="sgc-profile-info-value">{savedProfile.email || "—"}</span>
                  </div>
                </div>

                <div className="sgc-profile-info-item">
                  <div className="sgc-profile-info-icon"><Phone size={16} /></div>
                  <div>
                    <span className="sgc-profile-info-label">Phone</span>
                    <span className="sgc-profile-info-value">{savedProfile.phone || "—"}</span>
                  </div>
                </div>
              </div>
            </div>
          </Col>

          {/* ===== RIGHT: FORMS ===== */}
          <Col lg={8}>

            {/* ===== ACCOUNT INFORMATION ===== */}
            <div className="sgc-profile-card">
              <h2 className="sgc-profile-card-title">
                Account information
              </h2>
             {/* FULL NAME */}
              <div className="sgc-profile-field">
                <label className="sgc-profile-label">
                  Full name
                </label>
                <input
                  type="text"
                  className="sgc-profile-input"
                  value={fullname}
                  onChange={(e) =>
                    setFullname(e.target.value)
                  }
                />
              </div>
              {/* EMAIL */}
              <div className="sgc-profile-field">
                <label className="sgc-profile-label">
                  Email
                </label>
                <input
                  type="email"
                  className="sgc-profile-input"
                  value={email}
                  onChange={(e) =>
                    setEmail(e.target.value)
                  }
                />
              </div>
              {/* PHONE */}
             <div className="sgc-profile-field">
                <label className="sgc-profile-label">
                  Phone
                </label>
               <input
                  type="tel"
                  className="sgc-profile-input"
                  value={phone}
                  onChange={(e) =>
                    setPhone(e.target.value)
                  }
                />
              </div>
              {/* SAVE BUTTON */}
              <button
                className="sgc-profile-btn-save"
                onClick={updateProfile}
              >
                Save changes
              </button>

            </div>

            {/* ===== CHANGE PASSWORD ===== */}
            <div className="sgc-profile-card">
              <h2 className="sgc-profile-card-title">
                Change password
              </h2>
             {/* PASSWORD */}
              <div className="sgc-profile-field">
                <label className="sgc-profile-label">
                  New password
                </label>
                <input
                  type="password"
                  className="sgc-profile-input"
                  value={password}
                  onChange={(e) =>
                    setPassword(e.target.value)
                  }
                />
              </div>
              {/* UPDATE PASSWORD BUTTON */}
             <button
                className="sgc-profile-btn-outline"
                onClick={updatePassword}
              >
                Update password
              </button>

            </div>

          </Col>
        </Row>
      </div>
    </Container>
  );

};

export default Profile;